import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Loader from 'react-loader-spinner';
import { UserService } from '../../../../support/services/api';
import { Header } from '../../../components';

function PasswordStep({ email, password, setPassword, setStep }) {
  const [loading, setLoading] = useState(false);

  const retrievePassword = async () => {
    setLoading(true);
    try {
      await UserService(true).retrievePassword(email);
      toast(`Enviamos um email de recuperação de senha para ${email}`, { type: toast.TYPE.SUCCESS });
    } catch (err) {
      if (err.response?.data?.statusCode === 400) toast('Por favor, insira um email válido', { type: toast.TYPE.WARNING });
      else toast('Ops. Algo deu errado. Tente novamente mais tarde.', { type: toast.TYPE.ERROR });
    }
    setLoading(false);
  };

  return (
    <section className="step-container">
      <Header goBack={() => setStep(1)} />
      <h1 className="step-title">Identificamos que você já possui uma conta. Insira sua senha:</h1>

      <div className="step-input-group">
        <div className="floating-label-input">
          <input required disabled placeholder="E-mail" id="email" type="e-mail" name="email" value={email} />
          <label htmlFor="email">E-mail</label>
        </div>

        <div className="floating-label-input">
          <input required autoFocus placeholder="Senha" id="password" type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <label htmlFor="email">Senha</label>
        </div>
      </div>
      {
        !loading
          ? (
            <button className="clickable-label" onClick={retrievePassword}>
              Esqueci minha senha
            </button>
          )
          : (
            <Loader
              type="ThreeDots"
              color="#2d6fad"
              height={60}
              width={60}
              timeout={10000}
            />
          )
      }
    </section>
  );
}

export default PasswordStep;
